const enum GoogleAnalyticsEvent {
  PAGE_VIEW = 'page_view',
  FIRST_PAGE_COMPLETED = 'first_page_completed',
  ADD_TO_CART = 'add_to_cart',
  PURCHASE = 'purchase',
}

const enum GoogleAnalyticsEventCategory {
  TRANSITION = 'transition',
}

class GoogleAnalyticsService {
  logPageView(location: string): void {
    window.dataLayer &&
      window.dataLayer.push({
        event: GoogleAnalyticsEvent.PAGE_VIEW,
        page_path: `/${location}`,
      })
  }

  logFirstPageCompleted(): void {
    window.dataLayer &&
      window.dataLayer.push({
        event: GoogleAnalyticsEvent.FIRST_PAGE_COMPLETED,
        event_category: GoogleAnalyticsEventCategory.TRANSITION,
      })
  }

  logAddingToCart({
    productName,
    analyticsPrice,
  }: {
    productName: string
    analyticsPrice: number
  }): void {
    window.dataLayer &&
      window.dataLayer.push({
        event: GoogleAnalyticsEvent.ADD_TO_CART,
        items: [
          {
            id: productName,
            price: analyticsPrice,
          },
        ],
      })
  }

  logPurchaseCompleted({
    subscriptionId,
    productName,
    price,
    trialPrice,
    currency,
    email,
    predictedLtv,
  }: {
    subscriptionId: string
    productName: string
    price: number
    trialPrice: number
    currency: string
    email?: string
    predictedLtv?: number
  }): void {
    window.dataLayer &&
      window.dataLayer.push({
        event: GoogleAnalyticsEvent.PURCHASE,
        transaction_id: subscriptionId,
        value: predictedLtv || trialPrice || price,
        currency: predictedLtv ? 'USD' : currency,
        ...(email && { email }),
        items: [
          {
            id: productName,
            price: trialPrice || price,
          },
        ],
      })
  }
}

export const googleAnalyticsLogger = new GoogleAnalyticsService()
